import { PermissionEnum } from '@api/enum';
import useAuthPermission from '@hooks/use-auth-permission';
import { Table } from '@hyperflake/react-ui-library';
import { useAssetPurchaseOrderListData } from 'modules/asset-purchase-order/hooks/useAssetPurchaseOrderListData';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';

export const AssetPurchaseOrderList = () => {
    const { clientInstallationId, projectInstallationId } = useParams();
    const { hasPermission } = useAuthPermission();
    const navigate = useNavigate();

    const { purchaseOrderListData, isLoading } = useAssetPurchaseOrderListData(
        clientInstallationId,
        projectInstallationId
    );
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover
            isLoading={isLoading}
            data={purchaseOrderListData}
            columns={[
                {
                    header: 'ID',
                },
                {
                    header: 'Remarks',
                },
                {
                    header: 'Created At',
                },
                {
                    header: 'Created BY',
                },
                // {
                //     header: 'Status',
                // },
                // {
                //     header: 'Edit',
                // },
            ]}
            renderRow={(row) => (
                <Table.Row
                    key={row._id}
                    onClick={() => {
                        hasPermission(PermissionEnum.SITE_RECCE_UPDATE)
                            ? navigate(
                                  `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/purchase-order/${row._id}/edit`
                              )
                            : null;
                    }}
                >
                    <Table.Cell>
                        {
                            // <Link
                            //     to={`/clients/${row._id}/client-details`}
                            //     // to=""
                            //     // /clients/10212/projects/21091/cctv-cameras/98673426/edit-cctv
                            // >
                            //     <div className="text-primary">{row._id}</div>
                            // </Link>
                            <div className="text-primary">
                                {row._id}
                                {/* <Link to={`/client-installations/add`}>{row._id}</Link> */}
                            </div>
                        }
                    </Table.Cell>
                    <Table.Cell>
                        <div className="overflow-hidden text-ellipsis">{row?.remarks}</div>
                    </Table.Cell>
                    <Table.Cell>{moment(row?.createdAt, 'YYYYMMDD').format('DD MMM, YYYY')}</Table.Cell>
                    <Table.Cell>{row?.createdBy?.name || '-'}</Table.Cell>
                    {/*
                    <Table.Cell>
                        <Chip
                            label={row.priority}
                            color={
                                row.priority === SiteReccePriorityEnum.HIGH
                                    ? 'danger'
                                    : row.priority === SiteReccePriorityEnum.MEDIUM
                                    ? 'warning'
                                    : 'success'
                            }
                            variant="shaded"
                        />
                    </Table.Cell>
                    <Table.Cell>
                        {row.type ? (
                            <Chip
                                label={row.type}
                                color={
                                    row.type === SiteRecceTypeEnum.INITIAL_SITE_SURVEY
                                        ? 'primary'
                                        : row.type === SiteRecceTypeEnum.INSTALLATION
                                        ? 'warning'
                                        : row.type === SiteRecceTypeEnum.REMOVAL
                                        ? 'danger'
                                        : 'success'
                                }
                                variant="outlined"
                            />
                        ) : (
                            '-'
                        )}
                    </Table.Cell> */}
                </Table.Row>
            )}
        />
    );
};
